export class PersistedValue {
    constructor(key, value, version, ttl, storageTimeInSeconds = Math.round(new Date().getTime() / 1000)) {
        this.key = key;
        this.value = value;
        this.version = version;
        this.ttl = ttl;
        this.storageTimeInSeconds = storageTimeInSeconds;
    }
    getValueIfValid() {
        const currentTimeInSeconds = Math.round(new Date().getTime() / 1000);
        const expiryInSeconds = this.storageTimeInSeconds + this.ttl;
        if (currentTimeInSeconds > expiryInSeconds) {
            return undefined;
        }
        return this.value;
    }
    get() {
        return {
            key: this.key,
            value: this.value,
            version: this.version,
            ttl: this.ttl,
            storageTimeInSeconds: this.storageTimeInSeconds,
        };
    }
}
//# sourceMappingURL=PersistedValue.js.map